// 언어·공간 영역 (총 20문항)

export const iqVerbalQuestions = [
  {
    id: 65,
    category: 'verbal',
    question: '빈칸(?)에 들어갈 알파벳은?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['A', 'C', 'E'],
        ['G', 'I', 'K'],
        ['M', 'O', '?']
      ]
    },
    options: ['P', 'Q', 'R', 'S'],
    answer: 1,
    explanation: '알파벳이 2칸씩 뒤로 이동합니다. O에서 2칸 뒤는 Q입니다.',
  },
  {
    id: 66,
    category: 'verbal',
    question: '빈칸(?)에 들어갈 알파벳은?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['Z', 'X', 'V'],
        ['T', 'R', 'P'],
        ['N', 'L', '?']
      ]
    },
    options: ['K', 'J', 'I', 'M'],
    answer: 1,
    explanation: '알파벳이 거꾸로 2칸씩 이동합니다. L에서 2칸 앞은 J입니다.',
  },
  {
    id: 67,
    category: 'verbal',
    question: '빈칸(?)에 들어갈 알파벳은?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['A', 'D', 'G'],
        ['J', 'M', 'P'],
        ['S', 'V', '?']
      ]
    },
    options: ['X', 'Y', 'Z', 'W'],
    answer: 1,
    explanation: '알파벳이 3칸씩 뒤로 이동합니다. V에서 3칸 뒤는 Y입니다.',
  },
  {
    id: 68,
    category: 'verbal',
    question: '빈칸(?)에 들어갈 알파벳은?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['A', 'Z', 'C'],
        ['X', 'E', 'V'],
        ['G', 'T', '?']
      ]
    },
    options: ['H', 'I', 'J', 'K'],
    answer: 1,
    explanation: '홀수 번째는 A, C, E, G, I로 2칸씩 증가하고, 짝수 번째는 Z, X, V, T로 2칸씩 감소합니다. 다음은 I입니다.',
  },
  {
    id: 69,
    category: 'verbal',
    question: '빈칸(?)에 들어갈 방향은?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['E', 'S', 'W'],
        ['S', 'W', 'N'],
        ['W', 'N', '?']
      ]
    },
    options: ['E', 'W', 'N', 'S'],
    answer: 0,
    explanation: '동(E)·남(S)·서(W)·북(N)이 각 행과 열에 한 번씩 등장합니다. 마지막 칸에는 E가 들어갑니다.',
  },
  {
    id: 70,
    category: 'verbal',
    question: '빈칸(?)에 들어갈 화살표는?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['↑', '→', '↓'],
        ['→', '↓', '←'],
        ['↓', '←', '?']
      ]
    },
    options: ['→', '↓', '↑', '←'],
    answer: 2,
    explanation: '네 방향 화살표가 각 행과 열에 한 번씩 등장합니다. 마지막 칸에는 ↑가 들어갑니다.',
  },
  {
    id: 71,
    category: 'verbal',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['1', '6', '7'],
        ['2', '5', '7'],
        ['3', '4', '?']
      ]
    },
    options: ['8', '6', '7', '5'],
    answer: 2,
    explanation: '주사위에서 마주 보는 두 면의 합은 항상 7입니다. 3 + 4 = 7.',
  },
  {
    id: 72,
    category: 'verbal',
    question: '빈칸(?)에 들어갈 각도는?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['90', '60', '30'],
        ['60', '60', '60'],
        ['45', '45', '?']
      ]
    },
    options: ['45', '60', '90', '180'],
    answer: 2,
    explanation: '각 행의 세 각을 더하면 삼각형 내각의 합인 180°가 됩니다. 180 - 45 - 45 = 90.',
  },
  {
    id: 73,
    category: 'verbal',
    question: '빈칸(?)에 들어갈 숫자는?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['1', '11', '12'],
        ['2', '10', '12'],
        ['3', '9', '?']
      ]
    },
    options: ['11', '10', '12', '9'],
    answer: 2,
    explanation: '거울에 비친 시각과 실제 시각의 합은 12입니다. 3 + 9 = 12.',
  },

  /* ── 도형 겹치기 + 회전 (화면 90~100번) ── */
  {
    id: 74,
    category: 'logic',
    question: '각 행에서 2열은 1열을 90° 회전한 모양입니다. 두 도형을 합치는 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'compositeMatrix',
    visualData: {
      composites: [
        { frame: 'square', lines: ['h'] }, { frame: 'square', lines: ['v'] }, { frame: 'square', lines: ['h', 'v'] },
        { frame: 'square', lines: ['/'] }, { frame: 'square', lines: ['\\'] }, { frame: 'square', lines: ['x'] },
        { frame: 'square', lines: ['h', '/'] }, { frame: 'square', lines: ['v', '\\'] }, null
      ]
    },
    options: ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧'],
    optionVisualType: 'compositeShape',
    optionVisuals: [
      { composite: { frame: 'square', lines: ['+', 'x'] } },
      { composite: { frame: 'square', lines: ['x'] } },
      { composite: { frame: 'square', lines: ['+'] } },
      { composite: { frame: 'square', lines: ['h', '/'] } },
      { composite: { frame: 'square', lines: ['v', '\\'] } },
      { composite: { frame: 'circle', lines: ['+', 'x'] } },
      { composite: { frame: 'square', lines: ['h', 'v'] } },
      { composite: { frame: 'square', lines: ['/'] } }
    ],
    answer: 0,
    explanation: '2열은 1열의 선을 90° 회전한 모양입니다(가로↔세로, /↔\\). 두 선을 모두 합치는 합집합 규칙이므로 3행은 {h,/} ∪ {v,\\} = {h,v,/,\\} = +, x 모양입니다.',
  },
  {
    id: 75,
    category: 'pattern',
    question: '각 행에서 2열은 1열을 90° 회전한 모양입니다. 두 도형을 합치는 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'compositeMatrix',
    visualData: {
      composites: [
        { frame: 'diamond', lines: ['v'] }, { frame: 'diamond', lines: ['h'] }, { frame: 'diamond', lines: ['h', 'v'] },
        { frame: 'diamond', lines: ['x'] }, { frame: 'diamond', lines: ['x'] }, { frame: 'diamond', lines: ['x'] },
        { frame: 'diamond', lines: ['v', 'x'] }, { frame: 'diamond', lines: ['h', 'x'] }, null
      ]
    },
    options: ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧'],
    optionVisualType: 'compositeShape',
    optionVisuals: [
      { composite: { frame: 'diamond', lines: ['+', 'x'] } },
      { composite: { frame: 'diamond', lines: ['h', 'v'] } },
      { composite: { frame: 'diamond', lines: ['x'] } },
      { composite: { frame: 'diamond', lines: ['+'] } },
      { composite: { frame: 'square', lines: ['+', 'x'] } },
      { composite: { frame: 'diamond', lines: ['h', 'x'] } },
      { composite: { frame: 'diamond', lines: ['v', 'x'] } },
      { composite: { frame: 'diamond', lines: ['h'] } }
    ],
    answer: 0,
    explanation: '2열은 1열의 선을 90° 회전한 모양입니다. 두 선을 모두 합치는 합집합 규칙이므로 3행은 {v,x} ∪ {h,x} = {h,v,x} = +, x 모양입니다.',
  },
  {
    id: 76,
    category: 'pattern',
    question: '각 행에서 1열에서 2열의 선을 빼는 차집합 규칙입니다. 빈칸(?)에 들어갈 도형은?',
    visualType: 'compositeMatrix',
    visualData: {
      composites: [
        { frame: 'triangle', lines: ['h', 'v'] }, { frame: 'triangle', lines: ['v'] }, { frame: 'triangle', lines: ['h'] },
        { frame: 'triangle', lines: ['x', '/'] }, { frame: 'triangle', lines: ['/'] }, { frame: 'triangle', lines: ['x'] },
        { frame: 'triangle', lines: ['h', 'v', '/'] }, { frame: 'triangle', lines: ['v'] }, null
      ]
    },
    options: ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧'],
    optionVisualType: 'compositeShape',
    optionVisuals: [
      { composite: { frame: 'triangle', lines: ['h'] } },
      { composite: { frame: 'triangle', lines: ['/'] } },
      { composite: { frame: 'triangle', lines: ['h', 'v'] } },
      { composite: { frame: 'triangle', lines: ['h', '/'] } },
      { composite: { frame: 'square', lines: ['h', '/'] } },
      { composite: { frame: 'triangle', lines: ['x'] } },
      { composite: { frame: 'triangle', lines: ['v', '/'] } },
      { composite: { frame: 'triangle', lines: ['h', 'v', '/'] } }
    ],
    answer: 3,
    explanation: '1열에서 2열의 선을 빼는 차집합 규칙입니다. 3행은 {h,v,/} \\ {v} = {h,/} 입니다.',
  },
  {
    id: 77,
    category: 'pattern',
    question: '각 행에서 2열은 1열을 90° 회전한 모양입니다. 두 도형을 합치는 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'compositeMatrix',
    visualData: {
      composites: [
        { frame: 'circle', lines: ['h'] }, { frame: 'circle', lines: ['v'] }, { frame: 'circle', lines: ['h', 'v'] },
        { frame: 'circle', lines: ['/'] }, { frame: 'circle', lines: ['\\'] }, { frame: 'circle', lines: ['x'] },
        { frame: 'circle', lines: ['h', '/'] }, { frame: 'circle', lines: ['v', '\\'] }, null
      ]
    },
    options: ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧'],
    optionVisualType: 'compositeShape',
    optionVisuals: [
      { composite: { frame: 'circle', lines: ['+', 'x'] } },
      { composite: { frame: 'circle', lines: ['h', 'v'] } },
      { composite: { frame: 'circle', lines: ['x'] } },
      { composite: { frame: 'circle', lines: ['+'] } },
      { composite: { frame: 'square', lines: ['+', 'x'] } },
      { composite: { frame: 'circle', lines: ['h', '/'] } },
      { composite: { frame: 'circle', lines: ['v', '\\'] } },
      { composite: { frame: 'circle', lines: ['h'] } }
    ],
    answer: 0,
    explanation: '2열은 1열의 선을 90° 회전한 모양입니다. 두 선을 모두 합치는 합집합 규칙이므로 3행은 {h,/} ∪ {v,\\} = {h,v,/,\\} = +, x 모양입니다.',
  },
  {
    id: 78,
    category: 'logic',
    question: '각 행에서 두 도형이 겹치는 선만 남기는 교집합 규칙입니다. 빈칸(?)에 들어갈 도형은?',
    visualType: 'compositeMatrix',
    visualData: {
      composites: [
        { frame: 'square', lines: ['h', 'v'] }, { frame: 'square', lines: ['h'] }, { frame: 'square', lines: ['h'] },
        { frame: 'square', lines: ['x', '/'] }, { frame: 'square', lines: ['/'] }, { frame: 'square', lines: ['/'] },
        { frame: 'square', lines: ['h', 'v', '/'] }, { frame: 'square', lines: ['h', '/'] }, null
      ]
    },
    options: ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧'],
    optionVisualType: 'compositeShape',
    optionVisuals: [
      { composite: { frame: 'square', lines: ['h'] } },
      { composite: { frame: 'square', lines: ['/'] } },
      { composite: { frame: 'square', lines: ['h', '/'] } },
      { composite: { frame: 'square', lines: ['x'] } },
      { composite: { frame: 'square', lines: ['h', 'v'] } },
      { composite: { frame: 'circle', lines: ['h', '/'] } },
      { composite: { frame: 'square', lines: ['v', '/'] } },
      { composite: { frame: 'square', lines: ['+'] } }
    ],
    answer: 2,
    explanation: '두 도형이 겹치는 선만 남기는 교집합 규칙입니다. 3행은 {h,v,/} ∩ {h,/} = {h,/} 입니다.',
  },
  {
    id: 79,
    category: 'pattern',
    question: '각 행에서 1열에서 2열의 선을 빼는 차집합 규칙입니다. 빈칸(?)에 들어갈 도형은?',
    visualType: 'compositeMatrix',
    visualData: {
      composites: [
        { frame: 'hexagon', lines: ['h', 'v'] }, { frame: 'hexagon', lines: ['v'] }, { frame: 'hexagon', lines: ['h'] },
        { frame: 'hexagon', lines: ['x', '/'] }, { frame: 'hexagon', lines: ['/'] }, { frame: 'hexagon', lines: ['x'] },
        { frame: 'hexagon', lines: ['h', 'v', '/'] }, { frame: 'hexagon', lines: ['v'] }, null
      ]
    },
    options: ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧'],
    optionVisualType: 'compositeShape',
    optionVisuals: [
      { composite: { frame: 'hexagon', lines: ['h', 'v'] } },
      { composite: { frame: 'hexagon', lines: ['x'] } },
      { composite: { frame: 'hexagon', lines: ['h', '/'] } },
      { composite: { frame: 'hexagon', lines: ['/'] } },
      { composite: { frame: 'diamond', lines: ['h', '/'] } },
      { composite: { frame: 'hexagon', lines: ['h'] } },
      { composite: { frame: 'hexagon', lines: ['v', '/'] } },
      { composite: { frame: 'hexagon', lines: ['h', 'v', '/'] } }
    ],
    answer: 2,
    explanation: '1열에서 2열의 선을 빼는 차집합 규칙입니다. 3행은 {h,v,/} \\ {v} = {h,/} 입니다.',
  },
  {
    id: 80,
    category: 'pattern',
    question: '각 행에서 2열은 1열을 90° 회전한 모양입니다. 두 도형을 합치는 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'compositeMatrix',
    visualData: {
      composites: [
        { frame: 'square', lines: ['+'] }, { frame: 'square', lines: ['+'] }, { frame: 'square', lines: ['+'] },
        { frame: 'square', lines: ['x'] }, { frame: 'square', lines: ['x'] }, { frame: 'square', lines: ['x'] },
        { frame: 'square', lines: ['+', '/'] }, { frame: 'square', lines: ['+', '\\'] }, null
      ]
    },
    options: ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧'],
    optionVisualType: 'compositeShape',
    optionVisuals: [
      { composite: { frame: 'square', lines: ['+', 'x'] } },
      { composite: { frame: 'square', lines: ['x'] } },
      { composite: { frame: 'square', lines: ['+'] } },
      { composite: { frame: 'square', lines: ['h', 'v'] } },
      { composite: { frame: 'square', lines: ['+', '/'] } },
      { composite: { frame: 'circle', lines: ['+', 'x'] } },
      { composite: { frame: 'square', lines: ['+', '\\'] } },
      { composite: { frame: 'square', lines: ['/', '\\'] } }
    ],
    answer: 0,
    explanation: '2열은 1열의 선을 90° 회전한 모양입니다. 두 선을 모두 합치는 합집합 규칙이므로 3행은 {+,/} ∪ {+,\\} = {h,v,/,\\} = +, x 모양입니다.',
  },
  {
    id: 97,
    category: 'pattern',
    question: '각 행에서 2열은 1열을 90° 회전한 모양입니다. 두 도형이 겹치는 부분이 사라지는 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'overlapMatrix',
    visualData: {
      cells: [
        [[1,0,0],[1,0,0],[1,0,0]],
        [[1,1,1],[0,0,0],[0,0,0]],
        [[0,1,1],[1,0,0],[1,0,0]],
        [[1,1,1],[0,0,0],[0,0,0]],
        [[0,0,1],[0,0,1],[0,0,1]],
        [[1,1,0],[0,0,1],[0,0,1]],
        [[1,0,0],[0,1,0],[0,0,1]],
        [[0,0,1],[0,1,0],[1,0,0]],
        null
      ]
    },
    options: ['①', '②', '③', '④'],
    optionVisualType: 'blockGrid',
    optionVisuals: [
      { grid: [[1,0,1],[0,0,0],[1,0,1]] },
      { grid: [[1,0,1],[0,1,0],[1,0,1]] },
      { grid: [[0,0,0],[0,0,0],[0,0,0]] },
      { grid: [[1,0,0],[0,0,0],[0,0,1]] }
    ],
    answer: 0,
    explanation: '2열은 1열을 90° 회전한 모양입니다. 두 도형이 겹치는 부분이 사라지는 XOR 규칙이므로, 3행에서 두 대각선이 겹친 가운데 칸만 사라져 네 모서리만 남습니다.',
  },
  {
    id: 98,
    category: 'logic',
    question: '각 행에서 2열은 1열을 90° 회전한 모양입니다. 두 도형을 합치는 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'compositeMatrix',
    visualData: {
      composites: [
        { frame: 'hexagon', lines: ['h'] }, { frame: 'hexagon', lines: ['v'] }, { frame: 'hexagon', lines: ['h', 'v'] },
        { frame: 'hexagon', lines: ['/'] }, { frame: 'hexagon', lines: ['\\'] }, { frame: 'hexagon', lines: ['x'] },
        { frame: 'hexagon', lines: ['h', '/'] }, { frame: 'hexagon', lines: ['v', '\\'] }, null
      ]
    },
    options: ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧'],
    optionVisualType: 'compositeShape',
    optionVisuals: [
      { composite: { frame: 'hexagon', lines: ['+', 'x'] } },
      { composite: { frame: 'hexagon', lines: ['h', 'v'] } },
      { composite: { frame: 'hexagon', lines: ['x'] } },
      { composite: { frame: 'hexagon', lines: ['+'] } },
      { composite: { frame: 'square', lines: ['+', 'x'] } },
      { composite: { frame: 'hexagon', lines: ['h', '/'] } },
      { composite: { frame: 'hexagon', lines: ['v', '\\'] } },
      { composite: { frame: 'hexagon', lines: ['h'] } }
    ],
    answer: 0,
    explanation: '2열은 1열의 선을 90° 회전한 모양입니다. 두 선을 모두 합치는 합집합 규칙이므로 3행은 {h,/} ∪ {v,\\} = {h,v,/,\\} = +, x 모양입니다.',
  },
  {
    id: 99,
    category: 'pattern',
    question: '각 행에서 2열은 1열을 180° 회전한 모양입니다. 두 도형을 합치는 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'overlapMatrix',
    visualData: {
      cells: [
        [[1,1,0],[0,0,0],[0,0,0]],
        [[0,0,0],[0,0,0],[0,1,1]],
        [[1,1,0],[0,0,0],[0,1,1]],
        [[1,0,0],[1,0,0],[1,0,0]],
        [[0,0,1],[0,0,1],[0,0,1]],
        [[1,0,1],[1,0,1],[1,0,1]],
        [[1,1,0],[1,0,0],[0,0,0]],
        [[0,0,0],[0,0,1],[0,1,1]],
        null
      ]
    },
    options: ['①', '②', '③', '④'],
    optionVisualType: 'blockGrid',
    optionVisuals: [
      { grid: [[1,1,0],[1,0,1],[0,1,1]] },
      { grid: [[1,1,0],[0,0,0],[0,1,1]] },
      { grid: [[1,0,1],[1,0,1],[1,0,1]] },
      { grid: [[0,0,0],[0,1,0],[0,0,0]] }
    ],
    answer: 0,
    explanation: '2열은 1열을 180° 회전한 모양입니다. 두 도형을 모두 합치는 합집합 규칙이므로, 3행은 L자 도형과 그 180° 회전 모양을 합친 모양이 됩니다.',
  },
  {
    id: 100,
    category: 'pattern',
    question: '각 행에서 두 도형이 겹치는 선만 남기는 교집합 규칙입니다. 빈칸(?)에 들어갈 도형은?',
    visualType: 'compositeMatrix',
    visualData: {
      composites: [
        { frame: 'diamond', lines: ['+'] }, { frame: 'diamond', lines: ['h'] }, { frame: 'diamond', lines: ['h'] },
        { frame: 'diamond', lines: ['x'] }, { frame: 'diamond', lines: ['/'] }, { frame: 'diamond', lines: ['/'] },
        { frame: 'diamond', lines: ['+', '/'] }, { frame: 'diamond', lines: ['h', '/'] }, null
      ]
    },
    options: ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧'],
    optionVisualType: 'compositeShape',
    optionVisuals: [
      { composite: { frame: 'diamond', lines: ['/'] } },
      { composite: { frame: 'diamond', lines: ['h'] } },
      { composite: { frame: 'diamond', lines: ['h', '/'] } },
      { composite: { frame: 'diamond', lines: ['x'] } },
      { composite: { frame: 'diamond', lines: ['+'] } },
      { composite: { frame: 'square', lines: ['h', '/'] } },
      { composite: { frame: 'diamond', lines: ['h', 'v'] } },
      { composite: { frame: 'diamond', lines: ['+', '/'] } }
    ],
    answer: 2,
    explanation: '두 도형이 겹치는 선만 남기는 교집합 규칙입니다. 3행은 {h,v,/} ∩ {h,/} = {h,/} 입니다.',
  },
];